var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Media',{attrs:{"media-type":"category"}})
}
var staticRenderFns = []

export { render, staticRenderFns }